export const oveDetail = (state) => state.oveDetail
export const oveActions = (state) => state.oveActions
